var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.referredClients },
          on: { "expand-change": _vm.onExpandChange }
        },
        [
          _c("el-table-column", {
            attrs: { type: "expand" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          padding: "10px",
                          "background-color": "#f3eeee"
                        }
                      },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 10, type: "flex" } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c(
                                "div",
                                { staticClass: "info-item" },
                                [
                                  _c("div", { staticClass: "info-label" }, [
                                    _c("i", {
                                      staticClass: "el-icon-notebook-2"
                                    }),
                                    _vm._v(" Agent Notes\n                  ")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-form",
                                    {
                                      staticStyle: {
                                        "font-family": "DINosaur-a, sans-serif"
                                      },
                                      attrs: {
                                        "label-position": "top",
                                        "label-width": "100px"
                                      },
                                      nativeOn: {
                                        submit: function($event) {
                                          $event.preventDefault()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        { attrs: { gutter: 10 } },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: { label: "Agent Note" }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      type: "textarea",
                                                      rows: "3",
                                                      placeholder:
                                                        "Agent notes",
                                                      maxlength: "100",
                                                      "show-word-limit": ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.agentNotes[
                                                          scope.row.contactId
                                                        ],
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.agentNotes,
                                                          scope.row.contactId,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "agentNotes[scope.row.contactId]"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 24 } },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass: "add-note-btn",
                                                  attrs: {
                                                    icon: "el-icon-plus"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.addNote(
                                                        scope.row.contactId
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("Add Note")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 16 } }, [
                              _c("div", { staticClass: "info-item" }, [
                                _c("div", { staticClass: "info-label" }, [
                                  _vm._v("Agent Note History")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "info-content",
                                    staticStyle: {
                                      display: "block",
                                      width: "100%"
                                    }
                                  },
                                  [
                                    Array.isArray(
                                      _vm.agentNotesHistory[scope.row.contactId]
                                    ) &&
                                    _vm.agentNotesHistory[scope.row.contactId]
                                      .length > 0
                                      ? _c(
                                          "el-table",
                                          {
                                            staticClass: "compact-table",
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              data:
                                                _vm.agentNotesHistory[
                                                  scope.row.contactId
                                                ],
                                              height: "200",
                                              "row-style": _vm.rowStyle
                                            }
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "created",
                                                label: "Date",
                                                width: "180"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Channel Partner",
                                                width: "180"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(innerScope) {
                                                      return [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              innerScope.row
                                                                .cpFirstName +
                                                                " " +
                                                                innerScope.row
                                                                  .cpLastName
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                prop: "note",
                                                label: "Note"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              padding: "10px",
                                              "text-align": "center"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "empty-text" },
                                              [_vm._v("No notes available")]
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              ])
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "commission",
              "min-width": "40",
              align: "center",
              label: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.lessCommission
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: "danger",
                              effect: "dark"
                            }
                          },
                          [_vm._v(_vm._s(scope.row.commission) + "%")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "clientName",
              "min-width": "130",
              label: "Client Name"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "contactNumber",
              "min-width": "150",
              label: "Contact Number"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "email", "min-width": "150", label: "Email" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "propertyId",
              "min-width": "150",
              label: "Property Address"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.processPropertyAddress(scope.row)))
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "clientBudget",
              "min-width": "150",
              label: "Client Budget"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.formatCurrency(scope.row.clientBudget)))
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "reason", "min-width": "150", label: "Reason" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.truncateQuestion(scope.row.reason)))
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "comment", "min-width": "150", label: "Comment" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.truncateQuestion(scope.row.comment)))
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "created", "min-width": "200", label: "Date" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.created))])]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "propertyId", "min-width": "200", label: "Actions" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-link",
                        attrs: { type: "text", icon: "el-icon-more-outline" },
                        on: {
                          click: function($event) {
                            return _vm.moreDetailsOnReferredClient(scope.row)
                          }
                        }
                      },
                      [_vm._v("More\n          ")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "divider" }, [_vm._v(" | ")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-link",
                        attrs: { type: "text", icon: "el-icon-view" },
                        on: {
                          click: function($event) {
                            return _vm.showDetail(1, scope.row)
                          }
                        }
                      },
                      [_vm._v("View\n            Property\n          ")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.totalReferredClients
        ? _c(
            "div",
            { staticClass: "fen" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageReferredClients,
                  "page-size": 25,
                  layout: "total, prev, pager, next",
                  total: _vm.totalReferredClients
                },
                on: { "current-change": _vm.handleCurrentChange }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("el-dialog", {
        staticClass: "referred-client-dialog",
        attrs: {
          title: "Referred Client Details",
          visible: _vm.moreDetailsDialog,
          "append-to-body": true,
          "show-close": false,
          center: "",
          width: "500px"
        },
        on: {
          "update:visible": function($event) {
            _vm.moreDetailsDialog = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-row",
                          {
                            staticStyle: { padding: "3px 0" },
                            attrs: { gutter: 10 }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { span: 8 }
                              },
                              [_c("span", [_vm._v("Client Name: ")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { span: 16 }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "600" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.referredClientsAdditional.clientName
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticStyle: { padding: "3px 0" },
                            attrs: { gutter: 10 }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { span: 8 }
                              },
                              [_c("span", [_vm._v("Contact Number: ")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { span: 16 }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "600" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.referredClientsAdditional
                                          .contactNumber
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticStyle: { padding: "3px 0" },
                            attrs: { gutter: 10 }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { span: 8 }
                              },
                              [_c("span", [_vm._v("Email: ")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { span: 16 }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "600" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.referredClientsAdditional.email
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticStyle: { padding: "3px 0" },
                            attrs: { gutter: 10 }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { span: 8 }
                              },
                              [_c("span", [_vm._v("Your Name: ")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { span: 16 }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "600" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.referredClientsAdditional.yourName
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticStyle: { padding: "3px 0" },
                            attrs: { gutter: 10 }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { span: 8 }
                              },
                              [_c("span", [_vm._v("Client Budget: ")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { span: 16 }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "600" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatCurrency(
                                          _vm.referredClientsAdditional
                                            .clientBudget
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticStyle: { padding: "3px 0" },
                            attrs: { gutter: 10 }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { span: 8 }
                              },
                              [_c("span", [_vm._v("Client Name: ")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { span: 16 }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "600" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.referredClientsAdditional.clientName
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticStyle: { padding: "3px 0" },
                            attrs: { gutter: 10 }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { span: 8 }
                              },
                              [_c("span", [_vm._v("Reason: ")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { span: 16 }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "600" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.referredClientsAdditional.reason
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticStyle: { padding: "3px 0" },
                            attrs: { gutter: 10 }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { span: 8 }
                              },
                              [_c("span", [_vm._v("Comment: ")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { span: 16 }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "600" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.referredClientsAdditional.comment
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticStyle: { padding: "3px 0" },
                            attrs: { gutter: 10 }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: {
                                  "text-align": "center",
                                  padding: "20px 0 5px 0"
                                },
                                attrs: { span: 24 }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-weight": "600",
                                      "font-size": "16px"
                                    }
                                  },
                                  [_vm._v("Client Details for the Reservation")]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticStyle: { padding: "3px 0" },
                            attrs: { gutter: 10 }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { span: 8 }
                              },
                              [_c("span", [_vm._v("Name: ")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { span: 16 }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "600" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.processClientFullName(
                                          _vm.referredClientsAdditional
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticStyle: { padding: "3px 0" },
                            attrs: { gutter: 10 }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { span: 8 }
                              },
                              [_c("span", [_vm._v("Address: ")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { span: 16 }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "600" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.processClientAddress(
                                          _vm.referredClientsAdditional
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticStyle: { padding: "3px 0" },
                            attrs: { gutter: 10 }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { span: 8 }
                              },
                              [_c("span", [_vm._v("Email: ")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { span: 16 }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "600" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.referredClientsAdditional
                                          .emailAdditional
                                          ? _vm.referredClientsAdditional
                                              .emailAdditional
                                          : "N/A"
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticStyle: { padding: "3px 0" },
                            attrs: { gutter: 10 }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { span: 8 }
                              },
                              [_c("span", [_vm._v("Phone: ")])]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { span: 16 }
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-weight": "600" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.referredClientsAdditional.phone
                                          ? _vm.referredClientsAdditional.phone
                                          : "N/A"
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              background: "#003333",
                              border: "none",
                              width: "100%"
                            },
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                _vm.moreDetailsDialog = false
                              }
                            }
                          },
                          [_vm._v("Close\n            ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72ecbdb3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ecbdb3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enquiry/referredClientsTable.vue
// module id = null
// module chunks = 